import { gql } from '@apollo/client';

export const CREATE_STRIPE_CHECKOUT_SESSION = gql`
  mutation CreateCheckoutSession($input: CreateCheckoutSessionInput!) {
    createCheckoutSession(input: $input) {
      url
    }
  }
`;
